import { call, takeLatest } from "redux-saga/effects";

import {
  CUSTOM_REPORT_VALIDATE,
  CUSTOM_REPORT_EXECUTE,
  CUSTOM_REPORT_SAVE,
  CUSTOM_REPORT_LIST,
  CUSTOM_REPORT_GET,
  CUSTOM_REPORT_UPDATE,
  CUSTOM_REPORT_DELETE,
  CUSTOM_REPORT_SCHEMA,
  CUSTOM_REPORT_EXPORT_EXCEL,
  CUSTOM_REPORT_EXPORT_PDF,
  CUSTOM_REPORT_PARSE_PARAMETERS,
  CUSTOM_REPORT_EXECUTE_FUNCTION,
  CUSTOM_REPORT_SAVE_FUNCTION_REPORT,
  CUSTOM_REPORT_UPDATE_FUNCTION_REPORT,
} from "../types";
import {
  customReportValidateApi,
  customReportExecuteApi,
  customReportSaveApi,
  customReportListApi,
  customReportGetApi,
  customReportUpdateApi,
  customReportDeleteApi,
  customReportSchemaApi,
  customReportExportExcelApi,
  customReportExportPdfApi,
  customReportParseParametersApi,
  customReportExecuteFunctionApi,
  customReportSaveFunctionReportApi,
  customReportUpdateFunctionReportApi,
} from "../apis/custom-report-api";

export function* customReportValidateWorker(action) {
  try {
    const res = yield call(customReportValidateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportExecuteWorker(action) {
  try {
    const res = yield call(customReportExecuteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportSaveWorker(action) {
  try {
    const res = yield call(customReportSaveApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportListWorker(action) {
  try {
    const res = yield call(customReportListApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportGetWorker(action) {
  try {
    const res = yield call(customReportGetApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportUpdateWorker(action) {
  try {
    const res = yield call(customReportUpdateApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportDeleteWorker(action) {
  try {
    const res = yield call(customReportDeleteApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportSchemaWorker(action) {
  try {
    const res = yield call(customReportSchemaApi);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportExportExcelWorker(action) {
  try {
    const res = yield call(customReportExportExcelApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportExportPdfWorker(action) {
  try {
    const res = yield call(customReportExportPdfApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportValidateWatcher() {
  yield takeLatest(CUSTOM_REPORT_VALIDATE, customReportValidateWorker);
}

export function* customReportExecuteWatcher() {
  yield takeLatest(CUSTOM_REPORT_EXECUTE, customReportExecuteWorker);
}

export function* customReportSaveWatcher() {
  yield takeLatest(CUSTOM_REPORT_SAVE, customReportSaveWorker);
}

export function* customReportListWatcher() {
  yield takeLatest(CUSTOM_REPORT_LIST, customReportListWorker);
}

export function* customReportGetWatcher() {
  yield takeLatest(CUSTOM_REPORT_GET, customReportGetWorker);
}

export function* customReportUpdateWatcher() {
  yield takeLatest(CUSTOM_REPORT_UPDATE, customReportUpdateWorker);
}

export function* customReportDeleteWatcher() {
  yield takeLatest(CUSTOM_REPORT_DELETE, customReportDeleteWorker);
}

export function* customReportSchemaWatcher() {
  yield takeLatest(CUSTOM_REPORT_SCHEMA, customReportSchemaWorker);
}

export function* customReportExportExcelWatcher() {
  yield takeLatest(CUSTOM_REPORT_EXPORT_EXCEL, customReportExportExcelWorker);
}

export function* customReportExportPdfWatcher() {
  yield takeLatest(CUSTOM_REPORT_EXPORT_PDF, customReportExportPdfWorker);
}

export function* customReportParseParametersWorker(action) {
  try {
    const res = yield call(customReportParseParametersApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportExecuteFunctionWorker(action) {
  try {
    const res = yield call(customReportExecuteFunctionApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportSaveFunctionReportWorker(action) {
  try {
    const res = yield call(customReportSaveFunctionReportApi, action.data);
    if (res.status === 200 || res.status === 201) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportUpdateFunctionReportWorker(action) {
  try {
    const res = yield call(customReportUpdateFunctionReportApi, action.data);
    if (res.status === 200) {
      yield action.onSuccess(res.data);
    } else {
      yield action.onError(res?.data);
    }
  } catch (error) {
    yield action.onError(error?.response);
  }
}

export function* customReportParseParametersWatcher() {
  yield takeLatest(CUSTOM_REPORT_PARSE_PARAMETERS, customReportParseParametersWorker);
}

export function* customReportExecuteFunctionWatcher() {
  yield takeLatest(CUSTOM_REPORT_EXECUTE_FUNCTION, customReportExecuteFunctionWorker);
}

export function* customReportSaveFunctionReportWatcher() {
  yield takeLatest(CUSTOM_REPORT_SAVE_FUNCTION_REPORT, customReportSaveFunctionReportWorker);
}

export function* customReportUpdateFunctionReportWatcher() {
  yield takeLatest(CUSTOM_REPORT_UPDATE_FUNCTION_REPORT, customReportUpdateFunctionReportWorker);
}
